const AGGREGATION_TYPE = {
  YEAR: 'YEAR',
  MONTH: 'MONTH',
  DAY: 'DAY',
  HOUR: 'HOUR',
};

export default AGGREGATION_TYPE;
